export default function PublicNotFoundPage() {
  return (
    <div className="pub-404">
      <h1>404</h1>
      <p>页面未找到。</p>
    </div>
  )
}
